import styled from 'styled-components'

export const Container = styled.label`
  display: block;

  .input {
    outline: none;
    width: 348px;
    height: 34px;
    background-color: var(--white);
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    padding: 10px 16px;
    font-family: 'Inter';
    font-size: 18px;

    :focus {
      border: 2px solid var(--blue-800);
    }

    ::placeholder {
      font-size: 14px;
      color: var(--grey-500);
      letter-spacing: 0.5px;
      font-family: 'Inter';
    }

    @media (max-width: 400px) {
      width: 100%;
    }
  }

  .inputError {
    border: 1px solid red;
  }

  .error {
    color: red;
    font-size: 12px;
  }
`

export const Text = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`
